import {z} from 'zod';

export const JourneyStepOrchestrationSchema = z.object({
  startDate: z.date({coerce: true}).optional(),
  preRequiredSteps: z.array(z.string().uuid()).optional(),
});
export type JourneyStepOrchestration = z.infer<typeof JourneyStepOrchestrationSchema>;
